module.exports = __webpack_public_path__ + "img/437bf32.jpg";